class ScrollMagicImage extends HTMLElement {
  constructor() {
      super();

      // Check if browser window width is greater than 768 pixels
      if (window.innerWidth > 768) {
          // Set up GSAP timeline with ScrollTrigger
          let tl = gsap.timeline({
              scrollTrigger: {
                  trigger: this.querySelector('.scroll-magic-image-img'),
                  pin: false,
                  start: 'top center',
                  end: 'bottom center',
                  scrub: 1,
                  markers: false,
              },
          });

          tl.to(this.querySelector('.scroll-magic-image-img'), { width: '100%', duration: 5 }).addLabel('end');
      }
  }
}

customElements.define('scroll-magic-image', ScrollMagicImage);